const PasteTab = () => {
  return (
    <div className="flex flex-1 items-center justify-center text-base-500 py-12">
      Paste flow coming soon
    </div>
  )
}

export default PasteTab
